import React from "react";

const Exp = () => {
  return (
    <section id="about" className="w-full bg-dark-100 text-neutral-50">
      <div className="container max-w-[90rem] mx-auto flex items-center justify-center py-[2rem]">
        <p className="w-3/4 text-accent-300 leading-8 sm:leading-[54px] text-lg sm:text-xl text-center font-accent-about ">
          Frontend Developer with 3+ years of web development experience
          specializing in React and TypeScript. Domain expertise in EdTech and
          media platforms, with experience in both a service-based MNC and a
          product startup
        </p>
      </div>
    </section>
  );
};

export default Exp;
